import { Group, SimpleGrid, Stack, Text, Title } from '@mantine/core'
import { IconCopyCheck, IconPencil } from '@tabler/icons-react'
import { useTranslate } from 'react-admin'
import { useVideoPromotionStore } from '../../../../stores/useVideoPromotionStore'
import { IPromotionElementMode } from '../../../../types/components/VideoPromotion.type'
import { NewPromotionCard } from '../../NewPromotionCard/NewPromotionCard'
import { PromotionCopyInfoCards } from './PromotionCopyInfoCards'
import { PromotionDefineCards } from './PromotionDefineCards'

type ConfigTypeOption = 'defineCards' | 'copyInfocard'

export const NewPromotionElementInfocard = () => {
  const t = useTranslate()
  const videoPromotionStore = useVideoPromotionStore()
  const mode = videoPromotionStore.elementsConfiguration.infoCards.mode

  const configTypeOptions: {
    id: ConfigTypeOption
    mode: IPromotionElementMode
    icon: typeof IconPencil
  }[] = [
    { id: 'defineCards', mode: 'custom', icon: IconPencil },
    { id: 'copyInfocard', mode: 'copyFromVideo', icon: IconCopyCheck },
  ]
  return (
    <>
      <Title order={4} mt="lg">
        {t('pages.videoPromotion.configurationType')}
      </Title>
      <SimpleGrid cols={2} my="sm">
        {configTypeOptions.map(ct => (
          <NewPromotionCard
            key={ct.id}
            active={mode === ct.mode}
            onClick={() => videoPromotionStore.setElementMode('infoCards', ct.mode)}
          >
            <Stack gap="xs" h="100%">
              <Group gap="xs">
                <ct.icon size={18} />
                <Title order={5} size="md" fw={500}>
                  {t(`pages.videoPromotion.infoCards.configs.${ct.id}.title`)}
                </Title>
              </Group>
              <Text size="sm" fw="lighter" c="dimmed">
                {t(`pages.videoPromotion.infoCards.configs.${ct.id}.description`)}
              </Text>
            </Stack>
          </NewPromotionCard>
        ))}
      </SimpleGrid>
      {mode === 'custom' && <PromotionDefineCards />}
      {mode === 'copyFromVideo' && <PromotionCopyInfoCards />}
    </>
  )
}
